// Mobile swipe gesture for .owl-item.active
function enableOwlItemSwipeGesture() {
  function isMobile() {
    return window.innerWidth <= 768;
  }
  let startX = 0;
  let endX = 0;
  document.addEventListener('touchstart', function(e) {
    if (!isMobile()) return;
    const activeItem = document.querySelector('.recommended-carousel .owl-item.active');
    if (activeItem && activeItem.contains(e.target)) {
      startX = e.touches[0].clientX;
    }
  }, { passive: true });
  document.addEventListener('touchend', function(e) {
    if (!isMobile()) return;
    const activeItem = document.querySelector('.recommended-carousel .owl-item.active');
    if (activeItem && activeItem.contains(e.target)) {
      endX = e.changedTouches[0].clientX;
      const diff = endX - startX;
      if (Math.abs(diff) > 40) {
        if (diff < 0) {
          // Swipe left: go to next recommendation
          const nextBtn = document.querySelector('.recommended-carousel.owl-carousel .owl-nav .owl-next');
          if (nextBtn && !nextBtn.classList.contains('disabled')) {
            nextBtn.click();
          } else {
            // Fallback: call moveRecommendations with a fake event
            moveRecommendations({ currentTarget: { classList: { contains: (c) => c === 'owl-next' } } });
          }
        } else {
          // Swipe right: go to previous recommendation
          const prevBtn = document.querySelector('.recommended-carousel.owl-carousel .owl-nav .owl-prev');
          if (prevBtn && !prevBtn.classList.contains('disabled')) {
            prevBtn.click();
          } else {
            // Fallback: call moveRecommendations with a fake event
            moveRecommendations({ currentTarget: { classList: { contains: (c) => c === 'owl-prev' } } });
          }
        }
      }
    }
  }, { passive: true });
}
document.addEventListener('DOMContentLoaded', enableOwlItemSwipeGesture);
let elementsClose = document.querySelectorAll('#btn-minicart-close, #minicart-content-wrapper-empty button, .minicart-slide-wrapper .minicart-overlay');
elementsClose.forEach((element) => {
    element.addEventListener('click', () => {
        document.body.classList.remove('minicart-opened');
    });
})
let openButtons = document.querySelectorAll('[minicart-opener]');
openButtons.forEach((element) => {
    element.addEventListener('click', (event) => {
        event.preventDefault();
        document.body.classList.add('minicart-opened')
    })
})
let recommendedNavButtons = document.querySelectorAll('.recommended-carousel.owl-carousel .owl-nav .owl-prev, .recommended-carousel.owl-carousel .owl-nav .owl-next')
recommendedNavButtons.forEach((element) => {
  element.addEventListener('click',moveRecommendations)
});
const iso_code = window.Shopify.currency.show_currency_codes ? window.Shopify.currency.active : '';
function moveRecommendations(e) {
  const currentTarget = e.currentTarget;
  const action = currentTarget.classList.contains('owl-next') ? 'next' : 'prev';
  const currentSelectedElement = document.querySelector('.recommended-carousel.owl-carousel .owl-stage .owl-item.active');
  const nextButton = document.querySelector('.recommended-carousel.owl-carousel .owl-nav .owl-next');
  const prevButton = document.querySelector('.recommended-carousel.owl-carousel .owl-nav .owl-prev');
  if (currentSelectedElement) {
    let newActiveItem = currentSelectedElement;
    switch (action) {
      case 'next':
        if (currentSelectedElement.nextSibling) {
          prevButton.classList.remove('disabled');
          currentSelectedElement.classList.remove('active');
          currentSelectedElement.nextSibling.classList.add('active');
          newActiveItem = currentSelectedElement.nextSibling;
        }
        break;
      case 'prev':
        if (currentSelectedElement.previousSibling) {
          nextButton.classList.remove('disabled');
          currentSelectedElement.classList.remove('active');
          currentSelectedElement.previousSibling.classList.add('active');
          newActiveItem = currentSelectedElement.previousSibling;
        }
        break;
      default:
        break;
    }
    // Update dot active state
    const dots = document.querySelectorAll('.recommended-carousel .owl-dots .owl-dot');
    dots.forEach((dot) => {
      dot.classList.remove('active');
      if (dot.dataset.key && newActiveItem.dataset.key && dot.dataset.key === newActiveItem.dataset.key) {
        dot.classList.add('active');
      }
    });
    const newSelection = newActiveItem;
    if (newSelection.nextSibling == null) {
      nextButton.classList.add('disabled');
    } else {
      nextButton.classList.remove('disabled');
    }
    if (newSelection.previousSibling == null) {
      prevButton.classList.add('disabled');
    } else {
      prevButton.classList.remove('disabled');
    }
  }
}

async function updateQuantity(input, increase = true) {
  const productItem = input.closest('.product-item');
  const inputItem = input;
  const itemKey = inputItem.dataset.cartKey;
  let quantity = parseInt(input.value, 10);
  if (increase) {
    quantity += 1;
  } else {
    quantity -= 1;
  }
  if (quantity < 1) {
    // Remove item if quantity is 0
    //input.value = 0;
    // Simulate event for removeItemRquest
    const fakeEvent = { preventDefault: () => {}, currentTarget: productItem.querySelector('.action.delete') };
    removeItemRquest(fakeEvent);
    return;
  }
  input.value = quantity;

  // Disable buttons
  const increaseBtn = productItem.querySelector('.increaseQty');
  const decreaseBtn = productItem.querySelector('.decreaseQty');
  if (increaseBtn) increaseBtn.disabled = true;
  if (decreaseBtn) decreaseBtn.disabled = true;

  // POST request to update cart
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: quantity
        }
      })
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const cart = await response.json();
    updateCartElements(cart);
  } catch (error) {
    console.error('Error updating cart:', error);
  } finally {
    // Re-enable buttons
    if (increaseBtn) increaseBtn.disabled = false;
    if (decreaseBtn) decreaseBtn.disabled = false;
  }
}
function updateItemRquest(e) {
  e.preventDefault();
  let currentElement = e.currentTarget;
  let input = currentElement.parentElement.querySelector('input.cart-item-qty');
  let updates = {};
  updates[input.dataset.cartKey] = input.value;
  console.log(updates);
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(res => res.json())
  .then(response => {
    console.log(response)
    updateCartElements()
  });
}
function removeItemRquest(e) {
  e.preventDefault();
  if(confirm('Are you sure you would like to remove this item from the shopping cart?')){
    let currentElement = e.currentTarget;
    let updates = {};
    updates[currentElement.dataset.cartKey] = 0;
    console.log(updates);
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(res => res.json())
    .then(response => {
      console.log(response)
      updateCartElements()
    });
  }
}
function refreshQuantityButtons(){

  const increaseButtons = document.querySelectorAll('.input-group__button.increaseQty.minicart-control');
  increaseButtons.forEach((element) => {
    element.addEventListener('click', function(e) {
      const input = e.currentTarget.parentElement.querySelector('input.cart-item-qty');
      updateQuantity(input, true);
    });
  });
  const decreaseButtons = document.querySelectorAll('.input-group__button.decreaseQty.minicart-control');
  decreaseButtons.forEach((element) => {
    element.addEventListener('click', function(e) {
      const input = e.currentTarget.parentElement.querySelector('input.cart-item-qty');
      updateQuantity(input, false);
    });
  });

  const updateButtons = document.querySelectorAll('.minicart-items .update-cart-item')
  updateButtons.forEach((element) => {
    element.addEventListener('click',updateItemRquest)
  });

  const quantityInputs = document.querySelectorAll('.minicart-items .item-qty')
  quantityInputs.forEach((element) => {
    element.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const input = e.currentTarget;
        const parent = input.parentElement;
        const oldValue = parseInt(input.dataset.originalQuantity || input.defaultValue || 0, 10);
        const newValue = parseInt(input.value, 10);
        if (newValue === 0 && oldValue !== 0) {
          // Prevent further key/blur events
          e.preventDefault();
          e.stopPropagation();
          input._removalInProgress = true;
          input.value = oldValue;
          input.blur();
          // Simulate event for removeItemRquest
          const fakeEvent = { preventDefault: () => {}, currentTarget: input };
          removeItemRquest(fakeEvent);
        } else if (newValue !== oldValue) {
          updateItemRquest(e);
        }
      }
    });
    element.addEventListener('blur', (e) => {
      const input = e.currentTarget;
      const parent = input.parentElement;
      const oldValue = parseInt(input.dataset.originalQuantity || input.defaultValue || 0, 10);
      const newValue = parseInt(input.value, 10);
      const updateButton = parent.querySelector('button.update-cart-item');
      if (newValue === 0 && oldValue !== 0) {
        // Only remove if not already removed by Enter
        if (!input._removalInProgress) {
          input._removalInProgress = true;
          input.value = oldValue;
          const fakeEvent = { preventDefault: () => {}, currentTarget: input };
          removeItemRquest(fakeEvent);
        }
        setTimeout(() => { input._removalInProgress = false; }, 500);
      } else if (newValue !== oldValue) {
        updateItemRquest(e);
      } else {
        if(updateButton) updateButton.classList.add('hidden');
      }
    });
  });

  const removeButtons = document.querySelectorAll('.minicart-items .action.delete')
  removeButtons.forEach((element) => {
    element.addEventListener('click',removeItemRquest)
  });
}
refreshQuantityButtons();
var cartElementTempalte = `
              <div class="product">
                <a

                  tabindex="-1"
                  class="product-item-photo"
                  href="[[productRoute]]"
                  title="[[productTitle]]"
                >
                  <span class="product-image-container">
                    <span class="product-image-wrapper">
                        <figure class="lazy-image lazy-image--small product-image-photo lazyloaded" data-ratio="" style="padding-top: 120.00048000192001%">
                        <img src="[[itemImage]]?crop=center&amp;height=144&amp;v=1719256043&amp;width=120" alt="" loading="lazy" sizes="100px" width="805" height="805" onload="this.parentNode.classList.add('lazyloaded')">
                        </figure>
                    </span>
                  </span>
                </a>
                <div class="product-item-details">
                  <strong class="product-item-name">
                    <a
                      href="[[productRoute]]"
                      >[[productTitle]]</a
                    >
                  </strong>
                  <div class="product options">
                    <div data-role="content" class="content">
                      <dl class="product options list">
                          <dt class="label quantity">[[cart.mini_cart.quantity_of_no_quantity]] [[itemQuantityType]]</dt>
                          <dd class="values quantity">[[itemQuantityValue]]</dd>
                          <dt class="label selling-plan">[[cart.mini_cart.delivery]]</dt>
                          <dd class="values selling-plan">[[itemSellingPlanName]]</dd>
                      </dl>
                    </div>
                  </div>

                  <div class="product-item-pricing">
                    <div class="details-qty qty input-group">
                      <button
                        type="button"
                        class="input-group__button decreaseQty minicart-control"
                        data-cart-item="[[itemVarianId]]"
                        data-id="cart-item-[[itemVarianId]]-qty"
                        onclick="updateQuantity"
                      >
                        <svg aria-hidden="true" focusable="false" width="14" height="3">
                          <use xlink:href="#icon-minus"></use>
                        </svg>
                        <span >[[cart.mini_cart.buttons.decrease_quantity]]</span>
                      </button>
                      <input
                        type="number"
                        size="4"
                        class="item-qty cart-item-qty input-group__input minicart-control"
                        aria-label="item qty"
                        id="cart-item-[[itemVarianId]]-qty"
                        data-cart-item="[[itemVarianId]]"
                        data-original-quantity="[[itemQuantity]]"
                        data-cart-key="[[itemCartKey]]"
                        value="[[itemQuantity]]"
                      >
                      <button
                        type="button"
                        class="update-cart-item hidden"
                        id="update-cart-item-[[itemVarianId]]"
                        data-cart-item="[[itemVarianId]]"
                        title="[[cart.mini_cart.buttons.update_item]]"
                      >
                        <span >[[cart.mini_cart.buttons.update_item]]</span>
                      </button>
                      <button
                        type="button"
                        class="input-group__button increaseQty minicart-control"
                        data-cart-item="[[itemVarianId]]"
                        data-id="cart-item-[[itemVarianId]]-qty"
                        onclick="updateQuantity"
                      >
                        <svg aria-hidden="true" focusable="false" width="14" height="15">
                          <use xlink:href="#icon-plus"></use>
                        </svg>
                        <span >[[cart.mini_cart.buttons.increase_quantity]]</span>
                      </button>
                    </div>
                     <div class="secondary">
                      <a
                        href="/cart/change?line=[[indexLoop]]&amp;quantity=0"
                        class="action delete"
                        data-cart-key="[[itemCartKey]]"
                        data-cart-item="[[itemVarianId]]"
                        title="[[cart.mini_cart.buttons.remove_item]]"
                      >
                        <span ><svg aria-hidden="true" focusable="false" class="icon icon--delete " width="10.5" height="12.001" viewBox="0 0 10.5 12.001">
              <path d="M10.125-9.75H7.312l-.22-.438a.563.563,0,0,0-.5-.312H3.907a.555.555,0,0,0-.5.312l-.22.438H.375A.375.375,0,0,0,0-9.375v.75a.375.375,0,0,0,.375.375h9.75a.375.375,0,0,0,.375-.375v-.75A.375.375,0,0,0,10.125-9.75ZM1.247.445A1.126,1.126,0,0,0,2.37,1.5H8.13A1.126,1.126,0,0,0,9.253.445L9.75-7.5h-9Z" transform="translate(0 10.501)" fill="currentColor"></path>
            </svg></span>
                      </a>
                    </div>
                    <div class="price-container">
                      <span class="price-wrapper">
                        <span class="price-excluding-tax" data-label="Excl. Tax">
                          <span class="minicart-price"> <span class="price">[[itemFinalLinePrice]]</span></span>
                        </span>
                      </span>
                    </div>
                  </div>

                  <div class="product actions">
                    <div class="primary">
                    </div>                   
                  </div>
                </div>
              </div>
`;
var recommendedTempalte = `
  <div class="recommended-item-wrapper">
    <div class="store-header Logosite"></div>
    <div class="recommended-item">
      <div class="recommended-item__media">
        <a
          href="[[routesRoot]]products/[[productHandle]]"
        >
          <img
            class="recommended-item__image"
            loading="lazy"
            src="[[productImage]]?optimize=low&amp;fit=bounds&amp;height=135&amp;width=135"
            alt="[[productTitle]]"
            style="opacity: 1;"
          >
        </a>
      </div>
      <div class="recommended-item__details">
        <a
          class="recommended-item__title"
          href="[[routesRoot]]products/[[productHandle]]"
          >[[productTitle]]</a
        >

        <div class="recommended-item__details-addition">
          <span class="recommended-item__price" >[[productPrice]]</span>
          <a
            href="[[routesRoot]]products/[[productHandle]]"
            type="button"
            title="[[cart.mini_cart.buttons.view_details]]"
            class="action primary"
          >
            <span>[[cart.mini_cart.buttons.view]] <span class="mobile-hidden">[[cart.mini_cart.buttons.details]]</span></span>
          </a>
        </div>
      </div>
    </div>
  </div>
`;
function activeDot(e) {
  const currentTarget = e.currentTarget;
  const key = currentTarget.dataset.key;
  const container = document.querySelector('.recommended-carousel .owl-stage-outer .owl-stage');
  const dots = document.querySelectorAll('.recommended-carousel .owl-dots .owl-dot');
  dots.forEach((element) => {
    element.classList.remove('active')
  });
  currentTarget.classList.add('active');
  const elements = container.querySelectorAll('.owl-item');
  elements.forEach((element) => {
    element.classList.remove('active')
    if(element.dataset.key == key){
      element.classList.add('active')
    }
  });
}
function updateRecomendationsMinicart(productId) {
  fetch(window.Shopify.routes.root + 'recommendations/products.json?product_id='+productId+'&limit=3')
    .then(res => res.json())
    .then((response) => {
      if(response.products.length>0){
        const container = document.querySelector('.recommended-carousel .owl-stage-outer .owl-stage');
        const containerDots = document.querySelector('.recommended-carousel .owl-dots');
        container.innerHTML = '';
        containerDots.innerHTML = '';
        for(let x = 0; x < response.products.length; x++) {
          const element = response.products[x];
          if(!element.available){
            continue;
          }
          const containerDot = document.createElement('button');
          containerDot.type = 'button';
          containerDot.classList.add('owl-dot');
          containerDot.innerHTML = `<span></span>`;
          containerDot.onclick = activeDot;
          const containerRecommended = document.createElement('div');
          containerRecommended.classList.add('owl-item')
          containerRecommended.dataset.key = element.id;
          containerDot.dataset.key = element.id;
          if(x == 0) {
            containerDot.classList.add('active')
            containerRecommended.classList.add('active')
          }
          let newRecommendedItemTemplate = recommendedTempalte;
          newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[routesRoot]]',window.Shopify.routes.root);
          newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[productHandle]]',element.handle);
          newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[productTitle]]',element.title);
          newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[productImage]]',element.featured_image);
          //newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[productPrice]]',"$"+parseFloat(element.price/100).toFixed(2));
          newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[productPrice]]', formatMoney(element.price, KROWN.settings.shop_money_format_with_currency));

          newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[cart.mini_cart.buttons.view_details]]',KROWN.settings.locales.cart_mini_cart_buttons_view_details);
          newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[cart.mini_cart.buttons.view]]',KROWN.settings.locales.cart_mini_cart_buttons_view);
          newRecommendedItemTemplate = newRecommendedItemTemplate.replaceAll('[[cart.mini_cart.buttons.details]]',KROWN.settings.locales.cart_mini_cart_buttons_details);

          containerRecommended.innerHTML = newRecommendedItemTemplate
          container.appendChild(containerRecommended);
          containerDots.appendChild(containerDot);
        }
        const recommendations = document.querySelector('.block-minicart .recommended');
        if(!recommendations.classList.contains('loaded')){
          recommendations.classList.add('loaded')
        }
      }else{
        document.querySelector('.recommended ').classList.add('hide');
      }
    });
}
function updateCartElements(showMiniCart = true) {
    fetch(window.Shopify.routes.root + 'cart.json')
    .then(res => res.json())
    .then((response) => {
        const cartCurrent = response;
        let newCartItems = document.createElement('ol');
        newCartItems.innerHTML = '<div class="store-header Logosite"></div>';
        newCartItems.classList.add('minicart-items');
        if(cartCurrent.items.length > 0){
          updateRecomendationsMinicart(cartCurrent.items[0].product_id)
        }
        for(let x = 0; x < cartCurrent.items.length; x++){
          const item = cartCurrent.items[x];
          let containerItem = document.createElement('li');
          let propertyQuantityType = item.properties.__quantity_type ?? ''
          let propertyQuantityValue = item.properties.__quantity_value ?? '';

          containerItem.classList.add('item');
          containerItem.classList.add('product');
          containerItem.classList.add('product-item');
          containerItem.dataset.role = 'product-item'
          containerItem.dataset.productType = 'simple'
          let replace = cartElementTempalte;

          replace = replace.replaceAll('[[productRoute]]', item.url)
          replace = replace.replaceAll('[[itemCartKey]]', item.key)
          replace = replace.replaceAll('[[indexLoop]]', x+1)
          replace = replace.replaceAll('[[productTitle]]', item.product_title)
          replace = replace.replaceAll('[[itemImage]]', item.image)
          replace = replace.replaceAll('[[itemVarianId]]', item.variant_id)
          //replace = replace.replaceAll('[[itemFinalLinePrice]]', "$"+parseFloat(item.line_price / 100).toFixed(2)+" "+iso_code)
          replace = replace.replaceAll('[[itemFinalLinePrice]]',  formatMoney(item.line_price, KROWN.settings.shop_money_format_with_currency))
          replace = replace.replaceAll('[[itemQuantity]]', item.quantity)
          replace = replace.replaceAll('[[itemQuantityType]]', propertyQuantityType)
          replace = replace.replaceAll('[[itemQuantityValue]]', propertyQuantityValue)
          replace = replace.replaceAll('[[itemSellingPlanName]]', item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : KROWN.settings.locales.buy_once)

          for(let x = 0; x < KROWN.settings.locales.mini_cart_template.length; x++){
            replace = replace.replaceAll('[['+KROWN.settings.locales.mini_cart_template[x].replace_key+']]',KROWN.settings.locales.mini_cart_template[x].replace_value)
          }

          containerItem.innerHTML = replace;
          let properties = containerItem.querySelector('dl.product.options.list')
          if(propertyQuantityType == '') {
            let labelQuantity = properties.querySelector('dt.label.quantity')
            labelQuantity.remove()
          }
          if(propertyQuantityValue == ''){
            let valueQuantity = properties.querySelector('dd.values.quantity')
            valueQuantity.remove();
          }
          newCartItems.appendChild(containerItem)
        }
        let container = document.querySelector('.minicart-items-wrapper');
        let currentElementContainer = container.querySelector('ol');
        currentElementContainer.remove();
        container.prepend(newCartItems);
        const headerButtons = document.querySelectorAll('a[minicart-opener]')
        headerButtons.forEach((element) => {
          const headerCartItemsQuantity = element.querySelector('span[data-header-cart-count]');
          if(headerCartItemsQuantity){
            if(cartCurrent.item_count < 1){
              headerCartItemsQuantity.remove();
            }else {
              headerCartItemsQuantity.innerHTML = cartCurrent.item_count;
            }
          }else {
            const headerQuantity =  document.createElement('span');
            headerQuantity.dataset.headerCartCount = true
            headerQuantity.classList.add('element--wrap-paranth')
            headerQuantity.innerHTML = cartCurrent.item_count;
            element.appendChild(headerQuantity);
          }
        });
        refreshQuantityButtons();
        let estimatedPrice = document.querySelector('.block-minicart .minicart-footer .amount.price-container span.price')
        //estimatedPrice.innerHTML = "$"+parseFloat(cartCurrent.total_price / 100).toFixed(2)+" "+iso_code;
        estimatedPrice.innerHTML = formatMoney(cartCurrent.total_price, KROWN.settings.shop_money_format_with_currency)
        let freeShippingthresholdContainer = document.querySelector('.block-minicart .freeshipping-threshold')
        if(freeShippingthresholdContainer) {
          const threshold = freeShippingthresholdContainer.dataset.threshold * 100;
          let percentageContainer = freeShippingthresholdContainer.querySelector('.freeshipping-threshold__process div')
          const currentPercentage = (cartCurrent.total_price / threshold) * 100;
          const label = freeShippingthresholdContainer.querySelector('.freeshipping-threshold__message')
          let freeShipping = false;
          if(currentPercentage < 100 ){
            percentageContainer.style.width = currentPercentage + '%'
            //const missingMoney = parseFloat((threshold - cartCurrent.total_price) / 100).toFixed(2);
            const missingMoney = formatMoney((threshold - cartCurrent.total_price), KROWN.settings.shop_money_format_with_currency);
            label.innerHTML = KROWN.settings.locales.missing_money_for_free_shipping.replaceAll('{{ missing_money }}',missingMoney)
          } else {
            freeShipping = true;
          }

          for(let x = 0; x < cartCurrent.items.length; x++){
            let cart_item = cartCurrent.items[x];
            let propertiesKeys = Object.keys(cart_item.properties);
            if(propertiesKeys.includes('__appstle-selected-selling-plan')){
              freeShipping = true;
              break;
            }
          }

          if(freeShipping){
            label.innerHTML = KROWN.settings.locales.qualify_for_free_shipping;
            percentageContainer.style.width =  '100%'
          }
        }

        let cartHeaderCount = document.querySelector('#minicart-content-wrapper .qty span:first-child');
        let cartHeaderlabel = document.querySelector('#minicart-content-wrapper .qty span:last-child');
        cartHeaderCount.innerHTML = cartCurrent.item_count;
        cartHeaderlabel.innerHTML = cartCurrent.item_count > 1 ? ' items' : ' item'

        let containerMinicarteEmpty = document.querySelector('#minicart-content-wrapper-empty');
        let containerMinicarte = document.querySelector('#minicart-content-wrapper');
        if(cartCurrent.item_count < 1) {
          containerMinicarte.classList.add('hidden')
          containerMinicarteEmpty.classList.remove('hidden')
        } else {
          containerMinicarte.classList.remove('hidden')
          containerMinicarteEmpty.classList.add('hidden')
        }
        if ( document.getElementById('cart-recommendations') ) {
          document.getElementById('cart-recommendations').generateRecommendations();
        }
        if(!document.body.classList.contains('minicart-opened') && showMiniCart){
          document.body.classList.add('minicart-opened');
        }
    });
}
updateCartElements(false);
function serializePprForm(form) {
  const formData = new FormData(form);
  const result = {};

  formData.forEach((value, key) => {
      if (key.includes('[')) {
          const keys = key.split(/\[|\]/).filter(Boolean);
          let currentObject = result;

          for (let i = 0; i < keys.length; i++) {
              const currentKey = keys[i];
              if (!currentObject[currentKey]) {
                  if (i === keys.length - 1) {
                      currentObject[currentKey] = value;
                  } else {
                      currentObject[currentKey] = {};
                  }
              }
              currentObject = currentObject[currentKey];
          }
      } else {
          result[key] = value;
      }
  });

  return result;
}
var updateAddCartButtonsBehavior = () => {
  const addCartButtons = document.querySelectorAll('button[js-custom-add-to-cart]');
  addCartButtons.forEach((element) => {
    element.onclick = async (e) => {
      e.preventDefault();
      
      const formData = serializePprForm(e.currentTarget.form);
      const variantId = formData.id;
      const quantity = parseInt(formData.quantity || 1);
      
      try {
        // First, get current cart to check if product already exists
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.json');
        const currentCart = await cartResponse.json();
        
        // Check if this variant already exists in cart
        const existingItem = currentCart.items.find(item => item.variant_id == variantId);
        
        if (existingItem) {
          // Product exists, update quantity instead of adding
          const newQuantity = existingItem.quantity + quantity;
          const updates = {};
          updates[existingItem.key] = newQuantity;
          
          await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates })
          });
        } else {
          // Product doesn't exist, add normally
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            body: JSON.stringify(formData),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
        }
        
        updateCartElements();
      } catch (error) {
        console.error('Error:', error);
      }
    }
  })
}
updateAddCartButtonsBehavior();
document.addEventListener("shopify:block:load", updateAddCartButtonsBehavior);